import React from 'react';

import GlobalSearch from '..';
import { useStatsig } from '../../../hooks/useStatsig';

const GlobalSearchWrapper = (props) => {
    const { checkGate, featureGates } = useStatsig();
    const isGlobalDropdownV2Enabled = checkGate(featureGates.GLOBAL_DROPDOWN_V2);

    return (
        <GlobalSearch showGlobalSearchV2={isGlobalDropdownV2Enabled} {...props} />
    );
};

export default GlobalSearchWrapper;
